import flatpickr from 'flatpickr'

((window, document, $) => {
    // Exhibitions Toggle - Overlay for Small Viewports
    const getExhibitionsTrigger = () =>
        document.querySelector('.js--exhibitionsTrigger')

    const getExhibitionsClose = () =>
        document.querySelector('.js--exhibitionsClose')

    const getExhibitionsContainer = () =>
        document.querySelector('.exhibitions-container')

    const getMainSection = () =>
        document.querySelector('.section-main')

    if (getExhibitionsTrigger()
            && !getExhibitionsContainer())
        getExhibitionsTrigger().remove()

    if (getExhibitionsTrigger()
            && document.querySelector('footer.footer'))
        document.querySelector('footer.footer')
            .classList.add('footer-calendar')

    if (getExhibitionsTrigger())
        getExhibitionsTrigger()
            .addEventListener('click', (event) => {
                event.preventDefault()

                if (getExhibitionsContainer())
                    getExhibitionsContainer().classList
                        .add('exhibitions-container_open')

                getExhibitionsTrigger().classList
                    .add('hide')

                const mainSection = getMainSection()

                if (!mainSection || mainSection.style.zIndex)
                    return

                mainSection.style.zIndex = 1000
            })

    if (getExhibitionsClose())
        getExhibitionsClose()
            .addEventListener('click', (event) => {
                event.preventDefault()

                if (getExhibitionsContainer())
                    getExhibitionsContainer().classList
                        .remove('exhibitions-container_open')

                getExhibitionsTrigger().classList
                    .remove('hide')

                const mainSection = getMainSection()

                if (!mainSection || !mainSection.style.zIndex)
                    return

                mainSection.style.zIndex = ''
            })

    // Top-level Element
    const getCalendar = () =>
        document.querySelector('#calendar')

    const getCalendarForm = () =>
        document.querySelector('#calendar form')

    if (!getCalendar() || !getCalendarForm())
        return

    // Scroll to form if query params exist or on page greater then 1
    if (window.location.search.length
            || window.location.pathname.match(/\/page\/\d{1,}\/*/))
        window.addEventListener('load', () =>
            setTimeout(() => {
                getCalendar().focus()
                getCalendar().blur()
                window.scrollTo(0, $(getCalendar()).offset().top)
            }, 1))

    // Auto-submit form on changes
    const getCalendarRadios = () => Array.from(getCalendarForm()
        .querySelectorAll('input[type="checkbox"],input[type="radio"]'))

    getCalendarRadios()
        .forEach(el => el
            .addEventListener('change', (event) =>
                getCalendarForm().submit()))

    // Datepicker
    const datepicker = getCalendarForm()
        .querySelector('#calendar-datepicker')

    const datepickerBtn = datepicker
        ? datepicker.querySelector('.datepicker__btn')
        : null

    const datepickerField = datepicker
        ? datepicker.querySelector('.datepicker__field')
        : null

    const datepickerContainer = datepicker
        ? datepicker.querySelector('.datepicker__container')
        : null

    const datepickerContainerInner = datepicker
        ? datepicker.querySelector('.datepicker__container-inner')
        : null

    if (!datepicker
            || !datepickerBtn
            || !datepickerField
            || !datepickerContainer
            || !datepickerContainerInner)
        return

    const datepickerArrowSvg = `
        <svg class="ico-arrow-down" width="11" height="12">
            <use xlink:href="#ico-arrow-down"></use>
        </svg>
    `.replace(/(\n|\s+)/g, ' ').trim()

    let closedDays = []
    let closedDates = []

    try {
        closedDays = JSON.parse(datepicker
            .getAttribute('data-closed-days') || '[]')

        closedDates = JSON.parse(datepicker
            .getAttribute('data-closed-dates') || '[]')
    }
    catch (e) {
        console.warn(e)
    }

    closedDays = closedDays
        .map(str => Number(str))
        .filter(int => !isNaN(int))

    // AJAX to get event dates
    const onMonthChange = (instance = datepickerField._flatpickr) => {
        if (!instance)
            return

        window
            .fetch(`/ajax/events-by-month?date=${
                String(instance.currentMonth + 1).padStart(2, '0')}/01/${
                instance.currentYear}`)
            .then(response => response.text())
            .then((data) => {
                let dates = []

                try {
                    dates = JSON.parse(data || '[]')
                }
                catch (e) {
                    console.warn(e)
                }

                dates = dates
                    .map(str => String((new Date(str)).getDate()))

                const days = Array.from(instance.calendarContainer
                    .querySelectorAll('.flatpickr-day'))

                const noEventsDays = days
                    .filter(el => !el.classList.contains('prevMonthDay')
                        && !el.classList.contains('nextMonthDay')
                        && dates.indexOf(el.innerText) < 0)

                noEventsDays
                    .forEach(el => el.classList
                        .add('noEventsDay'))

                const eventDays = days
                    .filter(el => noEventsDays.indexOf(el) < 0)

                eventDays
                    .filter(el => el.classList.contains('closedDay'))
                    .forEach(el => el.classList.remove('closedDay'))
            })
    }

    flatpickr(datepickerField, {
        inline: true,
        disableMobile: true,
        appendTo: datepickerContainerInner,
        dateFormat: 'm/d/Y',
        prevArrow: datepickerArrowSvg,
        nextArrow: datepickerArrowSvg,
        monthSelectorType: 'static',
        onChange: (selectedDates, dateStr, instance) => {
            getCalendarRadios()
                .filter(el => el.name === 'date')
                .forEach(el => {
                    el.disabled = true
                    el.checked = false
                })

            datepickerField.disabled = false
            getCalendarForm().submit()
        },
        onMonthChange: () => onMonthChange(),
        onDayCreate: (dateObj, dateStr, instance, dayElem) => {
            const date = dayElem.dateObj
            const datestr = `${String((date.getMonth() + 1)).padStart(2, '0')}-${
                String(date.getDate()).padStart(2, '0')}-${
                (date.getFullYear())}`

            if (closedDays.indexOf(date.getDay()) >= 0
                    || closedDates.indexOf(datestr) >= 0)
                dayElem.classList.add('closedDay')
        },
        onReady: (selectedDates, dateStr, instance) => {
            Array
                .from(instance.weekdayContainer
                    .querySelectorAll('.flatpickr-weekdaycontainer span'))
                .forEach(el => {
                    el.innerText = el.innerText
                        .trim()
                        .substring(0, 1)
                })

            onMonthChange(instance)
        }
    })

    datepickerBtn
        .addEventListener('click', (event) => {
            event.preventDefault()

            datepickerContainer.classList
                .toggle('datepicker__container_open')
        })

    const onDatePickerClose = (event) => {
        if (!datepickerContainer.classList
            .contains('datepicker__container_open')
                || (event.type === 'click'
                    && (event.target === datepicker
                        || datepicker.contains(event.target))))
            return

        datepickerContainer.classList
            .remove('datepicker__container_open')
    }

    document.body
        .addEventListener('keyup', (event) => {
            if (event.keyCode !== 27)
                return

            event.preventDefault()
            onDatePickerClose(event)
        })

    document.body
        .addEventListener('click', onDatePickerClose)
})(window, document, window.jQuery)
